import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/index.vue";
import login from "../views/login/index.vue";
import login2 from "../views/login2/index.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/login1",
    name: "login1",
    component: login,
  },
  {
    path: "/login2",
    name: "login12",
    component: login2,
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
